import { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { chain, find } from "lodash"
import { Chip } from "@mui/material"
import classNames from "classnames"
import { OPTION_SHAPE } from "components/list-item-dropdown"
import { METRIC_OPTION_SHAPE } from "helpers/metrics/shapes"

export default function ChipSwitch({ metric, options, setValue, disabled }) {
  const [selected, setSelected] = useState()

  useEffect(() => {
    if (!selected) {
      setSelected(find(options, { isDefault: true }))
    }
  }, [options, selected])

  function makeClick(option, metric, id) {
    // Returning undefined here leverages the built in styling for <Chip />(non clickable)
    if (disabled) { return }

    return () => {
      setSelected(option)
      setValue(metric, id)
    }
  }

  return <div className="chip-switch">
    {chain(options)
      .thru((options) => disabled ? options.filter((option) => option.isDefault) : options)
      .map((option) => {
        const { id, label, unit } = option
        const isSelected = selected?.id === id
        let style = {}
        if (isSelected) {
          style = { color: disabled ? "default" : "primary", variant: "default" }
        } else {
          style = { color: "default", variant: "outlined" }
        }

        return <Chip
          size="small"
          key={id}
          className={classNames(id, { disabled, "selected-preference": isSelected })}
          label={`${label} (${unit})`}
          {...style}
          onClick={makeClick(option, metric, id)}
        />
      })
      .value()}
  </div>
}

ChipSwitch.propTypes = {
  options: PropTypes.arrayOf(METRIC_OPTION_SHAPE).isRequired,
  selectedOption: OPTION_SHAPE,
  setValue: PropTypes.func.isRequired,
  metric: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}
